import gql from 'graphql-tag';

export const GET_PROGRAMCYCLES_QUERY = gql`
  query programCycles {
    programcyclescanregister {
      id
      name
      zipCodesAccepted
      yearBuiltBeginDate
      yearBuiltEndDate
      multipleDwellings
      contractorAllowManual
      homeownerOccupied
      homeownerOccupiedOptionSet
      typeCode
      typeCodeOptionSet
      numberOfUnitsMin
      numberOfUnitsMax
      multipleEngineeredBidsRequired
      engineeredBidMustSubmitDoc
      maxBidAmount
      maxEngineeredBidAmount
    }
  }
`;
